import {
    DefaultDataService,
    EntityActionFactory,
    EntityCacheDispatcher,
    EntityOp,
    MergeStrategy,
    QueryParams
} from '@ngrx/data';
import { Observable, of } from 'rxjs/index';
import { Appointment } from '../../reminders/appointments/state/appointment.model';
import { entityActionFactory } from '../../reminders/appointment-list/state/appointment-list-entity-data-service.base';

// Inspiration:
// https://stackblitz.com/edit/ngrx-data-demo-7
// https://slides.com/jiali/deck-5#/10

export abstract class WebSocketEntityDataServiceBase<T> extends DefaultDataService<T> {

    /**
     * This is called by NgRx Data - triggered by a call to EntityCollectionServiceBase.getWithQuery()
     */
    getWithQuery(parameters: string | QueryParams): Observable<Array<T>> {

        const wsAction = parameters['wsAction'];
        if (wsAction) {
            return this.handleWebSocketAction(wsAction, parameters);
        }

        // TODO: Move to 'additional' param (that then needs to be JSON parsed?)
        const refreshing = parameters['refreshing'];

        if (refreshing !== undefined) {
            // There is no EntityOp or EntityAction for setting additionalCollectionState properties, so we pretend
            // we got empty entity from the backend and provide observable with empty entity data and the 'refreshing'
            // flag that the result handler will handle and provide proper action for the reducer method to update state.
            // The reducer will set refreshing to false on receiving data from the backend
            const fakeEntities = [];
            (fakeEntities as any).refreshing = true;

            return of(fakeEntities);
        }

        return undefined; // Let sub class handle other cases
    }

    handleWebSocketAction(wsAction: string, parameters: string | QueryParams): Observable<Array<T>> {
        // Since we're using getWithQuery() we need to return empty array
        const fakeEntities = [];

        switch (wsAction) {
            case 'subscribe':
                this.subscribeWebSocketJob(parameters);
                (fakeEntities as any).additional = {refreshing: true};
                // (fakeEntities as any).refreshing = true; // TODO: Add 'additional'
                break;

            case 'unsubscribe':
                this.unsubscribeWebSocketJob();
                break;

            case 'refresh':
                this.refreshWebSocketJob(parameters);
                (fakeEntities as any).additional = {refreshing: true};
                // (fakeEntities as any).refreshing = true; // TODO: Add 'additional'
                break;

            default:
        }

        return of(fakeEntities);
    }

    abstract subscribeWebSocketJob(parameters: string | QueryParams): void;

    abstract unsubscribeWebSocketJob(): void;

    abstract refreshWebSocketJob(queryParams: string | QueryParams): void;
}
